import { AfterViewInit, Component, Input } from '@angular/core'

@Component({
  selector: 'no-data',
  templateUrl: './no-data.component.html',
  styleUrls: ['./no-data.component.scss'],
})
export class NoDataComponent implements AfterViewInit {

  @Input() public message: string
  @Input() public margin_top: string = '20%'

  style = {}

  constructor () {
  }

  ngAfterViewInit () {
    this.style['margin-top'] = this.margin_top
  }

}
